import { render, staticRenderFns } from "./singleCardAccountList.vue?vue&type=template&id=bb51ab60&scoped=true"
import script from "./singleCardAccountList.vue?vue&type=script&lang=ts"
export * from "./singleCardAccountList.vue?vue&type=script&lang=ts"
import style0 from "./singleCardAccountList.vue?vue&type=style&index=0&id=bb51ab60&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb51ab60",
  null
  
)

export default component.exports